export const getChainName = (chainId: string) => {
  let chainName
  switch (chainId) {
    case '0x1':
      chainName = 'Mainnet'
      break
    case '0x4':
      chainName = 'Rinkeby'
      break
    default:
      chainName = 'Local'
  }
  return chainName
}

export const isMainnet = (chainId: string) => {
  return chainId === '0x1'
}
